module.exports = __webpack_public_path__ + "static/media/video1.bdce5d1e.png";